@if (showSpinner) {
  <div class="page-overlay-wrapper">
    <div class="spinner"></div>
    <br />
    <strong class="align_center"
      >Please wait while the transaction is being processed ...</strong
      >
    </div>
  }
